/* @flow weak */
export default function getActiveElement() {
  // IE may throw an error if activeElement is document.body.
  try {
    return document.activeElement || document.body;
  } catch (e) {
    return document.body;
  }
}



// WEBPACK FOOTER //
// ./src/utils/getActiveElement.js